import { AceClaim } from '@/core-types/claim';
import { RootState } from '../root-reducer';
import { PlanTypes } from '@/core-types/plan';

export const getClaims = (state: RootState): AceClaim[] =>
  state.user.claims.filter((i) => i?.plan?.planType === PlanTypes.ACE) as AceClaim[];

export const getactiveAceClaim = (state: RootState): Partial<AceClaim> => state.fileAceClaim.activeAceClaim;

export const mapApiInsertedClaim = (payload: unknown): Partial<AceClaim> => {
  return {
    id: payload['claim_id'],
  };
};
export const isDamageInfoModify = (current, modified) => {
  const keysToMatch = ['specificDamage', 'specificLocation', 'actionTaken', 'damageType', 'howDidOccur', 'notes'];

  const mappedCurrent = {
    specificLocation: current?.['specificLocation']?.['id'] || '',
    actionTaken: current?.['actionTaken']?.['id'] || '',
    damageType: current?.['type']?.['id'] || '',
    howDidOccur: current?.['occuredReason']?.['id'] || '',
    damageDate: current?.['damageDate'] || '',
    notes: current?.['notes'] || '',
  };

  return keysToMatch.some((key) => mappedCurrent[key] !== modified[key]);
};
